<template>
  <!-- Page length options -->
  <div class="card">
    <div>
      <div v-show="onload" class="content bg-white">
        <placeholder-content isLoad="true" />
      </div>
      <div v-if="!onload && !hasPermission">
        <access-denied></access-denied>
      </div>
      <div v-else-if="!onload && !hasComingSoon">
        <ComingSoon />
      </div>
      <div
        v-else-if="!isPlan"
        class="modal-body p-0 pb-5 px-0"
      >
        <AccessNotAvailable />
      </div>

      <div
        v-show="!onload && hasPermission && hasComingSoon && isPlan"
        class="card-header bg-white header-elements-inline"
      >
        <h5 class="card-title">{{ $t("Stock Aging Report") }}</h5>
      </div>
      <div v-show="!onload && hasPermission && hasComingSoon" class="card-body">
        <div v-show="onload">
          <div class="bg-white">
            <placeholder-content isLoad="true" />
          </div>
        </div>

        <!-- <div class="d-flex align-items-center justify-content-start"> -->
        <div v-show="!onload && isPlan">
          <div
            class="d-flex align-items-center justify-content-start mb-3 p-3 mt-n3 mx-n3 border-bottom"
          >
            <!-- product -->
            <div class="d-flex">
              <span class="d-flex mx-1 align-items-center">{{
                $t("Warehouse")
              }}</span>
              <Select2
                v-model="warehouse"
                :settings="settingOptionWare"
                style="min-width: 220px"
                @change="onValueChangeWarehouse"
              />
            </div>
            <div class="d-flex">
              <span class="d-flex mx-3 align-items-center">{{
                $t("Channels")
              }}</span>
              <Select2
                v-model="channel"
                :settings="settingsChannel"
                style="min-width: 220px"
                @change="onValueChangeChannel"
              />
            </div>
            <div class="d-flex">
              <span class="d-flex mx-3 align-items-center">{{
                $t("Product")
              }}</span>
              <Select2
                v-model="showText"
                :settings="settingsProduct"
                style="width: 280px"
                @change="onValueChange"
              />
            </div>

            <!-- perpage -->
            <div class="dataTables_length ml-auto mb-0">
              <PerPage @per-page="setPerPage" />
            </div>
          </div>
        </div>

        <div v-if="!onload && isPlan" class="d-flex d-flex flex-wrap">
          <div class="card mr-3">
            <div class="card-body" style=" width: 220px; ">
              <span
                class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"
                ><i style="font-size: 11px;" class="fa-solid fa-boxes-stacked"></i
              ></span>
              <h6 class="mb-0 font-weight-semibold">
                {{ $t("Number Of Products") }}
              </h6>
              <h3 class="text-grey-800 font-weight-semibold my-1">
                {{ totalQuantity | formatNumberDigit }}
              </h3>
            </div>
          </div>
          <!-- <div class="card mr-3">
            <div class="card-body" style=" width: 220px; ">
              <span
                class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"
                ><i class="fas fa-sack-dollar"></i
              ></span>
              <h6 class="mb-0 font-weight-semibold">{{ $t("Total Value") }}</h6>
              <h3 class="text-grey-800 font-weight-semibold my-1">
                {{ totalValue | formatNumber }}
              </h3>
            </div>
          </div> -->
        </div>

        <div class="card" v-show="!onload && isPlan">
          <div
            :class="[
              'table-responsive mt-0 data-nowrap table-hover table-order'
            ]"
            id="table-order"
          >
            <div
              :class="['vuetable-wrapper datatable-scroll']">
              <vuetable
                :class="[loadingTable]"
                ref="vuetable"
                :no-data-template="$t('No Data Available')"
                :fields="table.fields"
                data-path="data"
                pagination-path=""
                :api-mode="false"
                :data-manager="dataManager"
                @vuetable:loaded="vuetableLoaded"
                @vuetable:loading="vuetableLoading"
                @vuetable:pagination-data="onPaginationData"
                @vuetable:initialized="onInitialized"
              >

                <!-- :sort-order="sortOrder" -->

                <div slot="ch" slot-scope="props">
                  <img
                    v-tooltip:top="getTooltip(props.rowData)"
                    :data-original-title="getTooltip(props.rowData)"
                    class="image_box rounded"
                    :src="[
                      props.rowData.channel_id
                        ? props.rowData.channel_logo
                        : $storeIndex.getImageGobalAssets('icon-gosell')
                    ]"
                    alt=""
                  />
                </div>
                <div slot="image" slot-scope="props">
                  <ProductImageComponent
                    :product-id="props.rowData.product_reference_id"
                    :product-image-url="props.rowData.image_url"
                  />
                </div>
                <div slot="product_name" slot-scope="props">

                  <router-link
                  v-if="props.rowData.product_type == 'linked'"
                    :to="{ name: 't.a.productlink', query: {productLinkId: props.rowData.product_reference_id}}"
                    target="_blank"
                  >
                    <ProductNameComponent
                      :product-name="props.rowData.product_name"
                      :product-sku="props.rowData.product_sku"
                    />
                  </router-link>

                  <router-link
                    v-else
                    :to="{ name: 't.a.products', query: {productId: props.rowData.product_reference_id}}"
                    target="_blank"
                  >
                    <ProductNameComponent
                      :product-name="props.rowData.product_name"
                      :product-sku="props.rowData.product_sku"
                    />
                  </router-link>

                </div>
                <div
                  slot="warehouse_name"
                  slot-scope="props"
                >
                  <router-link
                    :to="{ name: 't.a.warehouse', query: {link: encodeLink(JSON.stringify({warehouseId: props.rowData.warehouse_id}))}}"
                    target="_blank"
                  >
                    <span
                      class="btn-link pointer mr-1 "
                    >{{ props.rowData.warehouse_name }}
                    </span>
                  </router-link>
                </div>

                <template slot="tableFooter">
                  <tr>
                    <th
                      v-for="(field, indexField) in dataFooterFields"
                      :class="field.dataClass"
                      class="position-relative"
                      :key="indexField + '_' + field.visible"
                    >
                      <template v-if="field.name == 'ch'">
                        <span
                          class="left-0 position-absolute text-nowrap top-0"
                          style="padding: .75rem 1.25rem"
                        >
                          {{ $t('Total Amount') }}
                        </span>
                      </template>
                      <template v-else-if="field.name == 'stock_0_30'">
                        {{ total0 | formatNumberDigit }}
                      </template>
                      <template v-else-if="field.name == 'stock_30_60'">
                        {{ total30 | formatNumberDigit}}
                      </template>
                      <template v-else-if="field.name == 'stock_60_90'">
                        {{ total60 | formatNumberDigit }}
                      </template>
                      <template v-else-if="field.name == 'stock_90_120'">
                        {{ total90 | formatNumberDigit }}
                      </template>
                      <template v-else-if="field.name == 'stock_120_plus'">
                        {{ total120 | formatNumberDigit }}
                      </template>
                    </th>
                  </tr>
                </template>
              </vuetable>
            </div>
          </div>
            <div class="datatable-footer">
              <vuetable-pagination-info
                class="dataTables_info ml-3"
                ref="paginationInfo"
                :no-data-template="$t('No relevant data')"
                :info-template="
                  $t('Displaying {from} to {to} of {total} items')
                "
              ></vuetable-pagination-info>
              <div class="dataTables_paginate paging_simple_numbers mb-0 mr-2">
                <vuetable-pagination
                  ref="pagination"
                  pagination-path="pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </div>
        </div>
      </div>
    </div>
    <!-- <FilterMore v-if="isFilter" @close="isFilter = false" /> -->
  </div>
</template>

<script>
import Api from "@/services/endpoint/tenant.service";
import PerPage from "../PerPage.vue";
import Select2 from "v-select2-component";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "@/plugins/vuetable-2/VuetablePaginationInfo";
import fields from "../assets/js/FieldStockAging.js";
import moment from "moment";
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import numeral from "numeral";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
import AccessNotAvailable from "@/components/tenancy/admin/error-page/templates/AccessNotAvailableV2.vue";
import SubscriptionExpired from "@/components/tenancy/admin/error-page/templates/SubscriptionExpired.vue";

import Cookies from "js-cookie";
import ComingSoon from "../../error-page/templates/ComingSoon.vue";
// import FilterMore from "./FiltersMoreInventory.vue";
import ApiWms from "@/services/endpoint/wms.service";
import ProductImageComponent from '@/components/tenancy/center/ProductImageComponent.vue';
import ProductNameComponent from '@/components/tenancy/center/ProductNameComponent.vue';

export default {
  components: {
    PerPage,
    Select2,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    PlaceholderContent,
    AccessDenied,
    SubscriptionExpired,
    ComingSoon,
    // FilterMore,
    ProductImageComponent,
    ProductNameComponent,
    AccessNotAvailable
  },
  data() {
    var self = this;
    return {
      wmsPermission: JSON.parse(Cookies.get('wmsServicePermission')),
      countFilter: 0,
      isFilter: false,
      hasComingSoon: true,
      checkedCount: 0,
      table: {
        fields: fields
      },
      loadingTable: "",
      paramsQuery: {
        limit: 10,
        page: 1,
        product_id: "",
        warehouse_id: "",
        product_type: "",
        channel_id: ""
      },
      query: {
        limit: 10,
        page: 1,
        product_id: "",
        warehouse_id: "",
        product_type: "",
        channel_id: ""
      },
      showText: "",
      product: "",
      warehouse: "",
      channel: "",
      ProductTypeSetting: {
        minimumResultsForSearch: Infinity,
        placeholder: this.$t("Product Type") + ".."
      },
      channelsList: [],
      loadProductType: false,
      onload: true,
      hasPermission: true,
      totalValue: 0,
      totalQuantity: 0,
      features: JSON.parse(Cookies.get('features')),
      isPlan: true,
      settingsProduct: {
        placeholder: this.$t("Select product") + "...",
        width: "300",
        ajax: {
          cache: true,
          delay: 250,
          url: ApiWms.AUTH.URL + ApiWms.URL.REPORT_GETPRODUCT,
          data: function(params) {
            var query = {
              search: params.term,
              status: "active",
              page: params.page || 1,
              limit: 10
            };
            if (self.paramsQuery.product_type) {
              query["type"] = self.paramsQuery.product_type;
            }
            return ApiWms.Signature.create($.param(query)).substring(1);
          },
          processResults: function(data) {
            let product = data.data;
            return {
              results: product
            };
          }
        },
        templateResult: this.templateProduct,
        templateSelection: this.templateCustomSelect,
        escapeMarkup: function(m) {
          return m;
        },
        allowClear: true
      },
      settingsChannel: {
        placeholder: this.$t("Select channel") + "...",
        width: "300",
        ajax: {
          cache: true,
          delay: 250,
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + Api.AUTH.TOKEN
            );
          },
          url: Api.AUTH.URL + Api.URL.INVENTORY_GETCHANNEL,
          data: function(params) {
            var query = {
              search: params.term,
              status: "active",
              type : "website_mkp",
              page: params.page || 1,
              limit: 10
            };
            return Api.Signature.create($.param(query)).substring(1);
          },
          processResults: function(data) {
            let product = data.data;
            self.channelsList = product;
            self.channelsList.unshift(
              {
                id: "system",
                name: "Manual Product",
                type: "Manual Product",
                code: "",
                logo: require('@/assets/images/icon-gosell.png'),
                group: "system",
                wms_id: "system"
              }
            )
            return {
              results: product
            };
          }
        },
        templateResult: this.templateChannel,
        templateSelection: this.templateCustomSelectChannel,
        escapeMarkup: function(m) {
          return m;
        },
        allowClear: true
      },
      settingOptionWare:{
          placeholder: {
            id: "",
            text: this.$t("_Transfer.Select warehouse")+'...',
          },
          templateResult: this.templateCustom,
          templateSelection: this.templateSelectWarehouse,
          allowClear: true,
          ajax: {
            cache: true,
            delay: 250,
          url: ApiWms.AUTH.URL + ApiWms.URL.ADJUSTMENTS_GETWAREHOUSE,
          data: function(params) {

              const query = {
                search: params.term,
                page: params.page || 1,
                limit: params.limit || 10
              }
              return ApiWms.Signature.create($.param(query)).substring(1);
          },
          processResults: (data) => {
            let option = data.data;
            // let pageCurrent = data.meta.current_page

            if (this.warehouseDataPlanLimit.length) {
              option.forEach((item, index) => {
                const itemLimit = this.warehouseDataPlanLimit.find((itemLimit) => itemLimit.id === item.id)
                item.disabled = itemLimit.disabled
              })
            }

            if (!this.warehouseDataPlanLimit.length) {
              option.sort((a, b) => {
                if (a.is_default !== b.is_default) {
                  return a.is_default ? -1 : 1;
                }
                return a.id - b.id;
              });

              let limit = parseInt(data.limit);

              option.forEach((item) => {
                if (limit) {
                  if (item.is_default) {
                    item.disabled = false
                    limit--
                    return
                  }

                  item.disabled = false
                  limit--
                  return
                }
                item.disabled = true
              });

              option.sort((a, b) => b.id - a.id);

              this.warehouseDataPlanLimit = option
            }

            option = option.map( function(item) {
              return {
                id: item.id,
                text: item.name,
                color: item.color,
                ctid: item.id,
                disabled: item.disabled
              }
            })
            return {
              results: option,
              // pagination: {
              //   more: (pageCurrent * 10) < data.meta.total
              // }
            };
          }
        }
      },
      filtersMore: [],
      dataFooterFields: [],
      vuetableFields: false,
      dataTable: [],
      warehouseDataPlanLimit: [],
      loadingTable: "",
      urlProduct: ApiWms.AUTH.URL + ApiWms.URL.REPORT_GETPRODUCT
    };
  },
  computed: {
    total0() {
      let dataTable = this.dataTable.data;
      if (dataTable && dataTable.length > 0) {
        let totalCount = dataTable.map((item) => { return parseFloat(item.stock_0_30); });

        return totalCount.reduce((total, item) => total + item);
      }else {
        return 0
      }
    },
    total30() {
      let dataTable = this.dataTable.data;
      if (dataTable && dataTable.length > 0) {
        let totalCount = dataTable.map((item) => { return parseFloat(item.stock_30_60); });

        return totalCount.reduce((total, item) => total + item);
      }else {
        return 0
      }
    },
    total60() {
      let dataTable = this.dataTable.data;
      if (dataTable && dataTable.length > 0) {
        let totalCount = dataTable.map((item) => { return parseFloat(item.stock_60_90); });

        return totalCount.reduce((total, item) => total + item);
      }else {
        return 0
      }
    },
    total90() {
      let dataTable = this.dataTable.data;
      if (dataTable && dataTable.length > 0) {
        let totalCount = dataTable.map((item) => { return parseFloat(item.stock_90_120); });

        return totalCount.reduce((total, item) => total + item);
      }else {
        return 0
      }
    },
    total120() {
      let dataTable = this.dataTable.data;
      if (dataTable && dataTable.length > 0) {
        let totalCount = dataTable.map((item) => { return parseFloat(item.stock_120_plus); });

        return totalCount.reduce((total, item) => total + item);
      }else {
        return 0
      }
    },
    footerTableFields() {
      if(this.vuetableFields !== false) {
        return this.$refs.vuetable.tableFields;
      }else {
        return [];
      }
    }
  },
  methods: {
    dataManager(sortOrder, pagination) {
      this.onload = true;
      this.setParams();
    },
    onPaginationData(tablePagination) {
      this.$refs.paginationInfo.setPaginationData(tablePagination);
      this.$refs.pagination.setPaginationData(tablePagination);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    setPerPage(perPage) {
      this.paramsQuery.current_page = 1;
      this.$refs.vuetable.currentPage = 1;
      this.paramsQuery.limit = perPage;
      this.setParams();
    },
    vuetableLoaded() {
      this.loadingTable = "";
    },
    vuetableLoading() {
      this.loadingTable = "loading"
    },
    async setParams(page = 0) {
      if(!this.features.includes('report-stock-ageing')) {
        // report-stock-ageing
        this.onload = false;
        this.isPlan = false;
        return;
      }
      if(!this.wmsPermission.includes('stock_ageing_report_view')) {
        // stock_ageing_report_view permission ของ stock aging report
        this.onload = false;
        this.hasPermission = false;
        return;
      }

      try {
        // this.onload = true;
        this.loadingTable = "loading";

        this.query.page = this.$refs.vuetable.currentPage;
        if (page) {
          this.query.page = page;
        }
        this.query.limit = this.paramsQuery.limit;
        this.query.product_id = this.paramsQuery.product_id;
        this.query.product_type = this.paramsQuery.product_type;
        this.query.warehouse_id = this.paramsQuery.warehouse_id;

        if (this.paramsQuery.channel_id == 'system') {
          delete this.query.channel_id;
          this.query.manual = 1;
        } else {
          delete this.query.manual;
          this.query.channel_id = this.paramsQuery.channel_id;
        }

        let queryString = "";
        if (this.paramsQuery) {
          queryString += "?" + $.param(this.query);
        }


        let response = await ApiWms.Report.getStockAgingList(queryString);
        this.dataTable = response.data;
        const from = (response.data.page - 1) * response.data.limit + 1; // เริ่มที่ 1 ของหน้า
        const to = Math.min(
          response.data.page * response.data.limit,
          response.data.total_rows
        ); // ค่าสิ้นสุดไม่เกินจำนวนทั้งหมด
        let meta = {
          current_page: response.data.page,
          from: from,
          last_page: response.data.total_pages,
          per_page: response.data.limit,
          to: to,
          total: response.data.total_rows
        };
        Object.assign(response.data, { meta: meta });

        const data = this.$storeIndex.mutations.vueTableFormatJson(response);
        this.$refs.vuetable.setData(data);

        this.totalQuantity = response.data.optional_data.total_product;

        this.loadingTable = "";
        // this.hasPermission = false;
        this.onload = false;
      } catch (error) {
        this.hasComingSoon = false;
        this.onload = false;
        this.hasPermission = true;

        console.log(error, "error");
      }
    },
    setQuerystring(obj) {
      this.$router
        .push({
          query: Object.assign({}, this.$route.query, obj)
        })
        .catch(() => {});
    },
    noResults() {
      return this.$t("No Result Found");
    },
    templateProduct(e) {
      let option = "";
      if (e.text == "Searching…") {
        option = this.$t("Searching...");
      } else {
        let skuNew = e.sku == "" || e.sku == null ? "-" : e.sku;

        let imageChannel = "";
        if (e.channel_logo) {
          imageChannel = e.channel_logo;
        } else {
          imageChannel = e.integration
            ? e.integration.integration_type.logo
            : this.$storeIndex.getImageGobalAssets("icon-gosell");
        }

        let channelName = e.integration
          ? e.integration.name
          : this.$t("Manual Product");
        let tooltipChannel = e.integration
          ? e.integration.integration_type.name + "/" + e.integration.name
          : this.$t("Manual Product");
        let linkProduct =
          e.omni_link_id != null
            ? '<span class="mx-2"><span class="badge bg-teal mr-2">' +
              this.$t("Linked") +
              "</span></span>"
            : "";
        let selectedProduct =
          e.selected && e.omni_link_id == null
            ? '<span class="mx-2"><span class="badge bg-danger-400 mr-2">' +
              this.$t("Selected") +
              "</span></span>"
            : "";

        if (e.connected) {
          selectedProduct =
            '<span class="mx-2"><span class="badge bg-info-400 mr-2">' +
            this.$t("Connected") +
            "</span></span>";
        }

        let bgDisable =
          e.connected || e.disabled || e.selected ? "bg-disable" : "";

        var image =
          '<img class="thumb32 rounded mr-3" src="' +
          this.$storeIndex.getImageSrc("channel/none") +
          '">';
        if (this.$storeIndex.isset(() => e.images) && e.images.length > 0) {
          image =
            '<img class="thumb32 rounded mr-3" src="' +
            (this.$storeIndex.isset(() => e.images[0]) ? e.images[0] : "") +
            '">';
        }
        option =
          "<div class='d-flex align-items-center pd-6px " + bgDisable + "'>";
        option +=
          "<div class='item-image ml-1'>" +
          image +
          "</div><div class='item-content w-100'>";
        option +=
          "<div class='font-weight-semibold item-name' style='word-wrap: break-word;'>" +
          e.name +
          linkProduct +
          selectedProduct +
          "</div>";

        option +=
          "<span class='mr-2'>" + this.$t("SKU") + ": " + skuNew + "</span>";

        option +=
          "<div class='item-bottom row ml-0'><img data-toggle='" +
          tooltipChannel +
          "'data-placement='top' title='" +
          tooltipChannel +
          "' class='rounded pointer mr-2' width='20' height='20' src=' " +
          imageChannel +
          " ' alt=''>" +
          "<span class='mr-2'>" +
          channelName +
          "</span>" +
          "</div>";
        option += "</div>";
        option += "</div>";
      }
      return option;
    },
    templateChannel(e) {
      let option = "";
      if (e.text == "Searching…") {
        option = this.$t("Searching...");
      } else {

        let imageChannel = "";
        if (e.logo) {
          imageChannel = e.logo;
        } else {
          imageChannel = e.integration
            ? e.integration.integration_type.logo
            : this.$storeIndex.getImageSrc("channel/none");
        }

        let channelName = e.name
          ? e.name
          : this.$t("Manual Product");
        let tooltipChannel = e.type
          ? e.type + "/" + e.name
          : this.$t("Manual Product");

        if (this.$storeIndex.isset(() => e.images) && e.images.length > 0) {
          image =
            '<img class="thumb32 rounded mr-3" src="' +
            (this.$storeIndex.isset(() => e.images[0]) ? e.images[0] : "") +
            '">';
        }

        option +=
          "<div class='item-bottom row ml-0'><img data-toggle='" +
          tooltipChannel +
          "'data-placement='top' title='" +
          tooltipChannel +
          "' class='rounded pointer mr-2' width='20' height='20' src=' " +
          imageChannel +
          " ' alt=''>" +
          "<span class='mr-2'>" +
          channelName +
          "</span>" +
          "</div>";
        option += "</div>";
        option += "</div>";
      }
      return option;
    },
    templateCustomSelect: function(data) {
      if (!data.id) {
        return data.text || "Select Product...";
      }
      this.paramsQuery.product_id = data.id;
      return `<span>${data.name || data.text}</span>`;
    },
    templateCustomSelectChannel: function(data) {
      let option = "";
      if (!data.id) {
        return data.text || "Select Channels...";
      }
      // this.paramsQuery.channel_id = data.id;
      let imageChannel = data.logo ? data.logo : this.$storeIndex.getImageSrc("channel/none");
      let tooltipChannel = data.type
        ? data.type + "/" + data.name
        : this.$t("Manual Product");

      option +=
          "<div class='item-bottom row ml-0'><img data-toggle='" +
          tooltipChannel +
          "'data-placement='top' title='" +
          tooltipChannel +
          "' class='rounded pointer mr-2 mt-1' width='20' height='20' src=' " +
          imageChannel +
          " ' alt=''>" +
          "<span class='mr-2'>" +
            data.name +
          "</span>" +
          "</div>";
        option += "</div>";
        option += "</div>";

        return option;

      // return `<div class='list-item d-flex templateselect'><img class='my-1 rounded pointer mr-2' width='20' height='20' src=' " +
      //     ${imageChannel} +
      //     " ' alt=''><span>${data.name || data.text}</span></div>`;
    },
    onValueChange(value) {
      if (!value) {
        this.paramsQuery.product_id = "";
      }
      this.setParams(1);
    },
    onValueChangeWarehouse(value) {
      if (!value) {
        this.paramsQuery.warehouse_id = "";
      } else {
        this.paramsQuery.warehouse_id = value;
        this.urlProduct = ApiWms.AUTH.URL + ApiWms.URL.INVENTORY_GETPRODUCT
      }
      this.setParams(1);
    },
    onValueChangeChannel(value) {
      if (!value) {
        this.paramsQuery.channel_id = "";
      } else {
        const selected = this.channelsList.find(item => item.id == value);
        this.paramsQuery.channel_id = selected.wms_id;
      }
      this.setParams(1);
    },
    openFilter() {
      this.isFilter = true;
      this.$nextTick(() => {
        this.isFilter = true;
      });
    },
    filterinfo(data) {
      this.paramsQuery = data;
      this.setParams();
    },
    getOnClickData(action, data, id) {
      return {
        action: action,
        data: data,
        id: id
      };
    },
    getTooltip(rowData) {
      let channelDetail = '';
      if (rowData.integration == null) {
        channelDetail = 'Manual Product';
      } else {
        channelDetail = rowData.channel_name + ' / ' + rowData.channel_name;
      }
      return channelDetail;
    },
    encodeLink (data) {
      // return btoa(data)
      return btoa(unescape(encodeURIComponent(data)));
    },
    onInitialized(fields) {
      this.vuetableFields = fields.filter((field) => field.togglable);
    },
  },
  async mounted() {
  },
  watch: {
    footerTableFields: {
      handler: function (nval, oval) {
        let newFooterTableArray = [];
        nval.forEach(element => {
          if (element.visible === true) {
            newFooterTableArray.push(element)
          }
        });
        this.$nextTick(() => {
          this.dataFooterFields = newFooterTableArray;
        });
      },
      deep: true
    }
  },
  filters: {
    formatNumber: function(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit: function(value) {
      return numeral(value).format("0,0");
    }
  }
};
</script>

<style>
.product-search-n-1
  .select2-container--default
  .select2-selection--multiple
  .select2-search--inline
  .select2-search__field {
  width: 100% !important;
}
</style>




// WEBPACK FOOTER //
// src/components/tenancy/admin/report/inventory/StockAgingReport.vue